<template>
    <div>
        <div class="row justify-content-center alig-items-center">
            <div class="col-12">
                <div class="prev-next">
                    <ul>
                        <li v-if="currentPage > 1">
                            <button @click="setCurrentPage(currentPage - 1)">
                                <i class="fas fa-long-arrow-alt-left"></i>
                            </button>
                        </li>
                        <li v-if="currentPage > 3 && totalPages > 5">
                            <button>...</button>
                        </li>
                        <li v-for="pageNr in pageButtonsArray()" :key="pageNr">
                            <button
                                v-if="pageNr !== currentPage"
                                @click="setCurrentPage(pageNr)"
                            >
                                {{ pageNr }}
                            </button>
                            <button
                                v-if="pageNr === currentPage"
                                @click="setCurrentPage(pageNr)"
                            >
                                <strong>{{ pageNr }}</strong>
                            </button>
                        </li>
                        <li
                            v-if="
                                currentPage < totalPages - 2 && totalPages > 5
                            "
                        >
                            <button>...</button>
                        </li>
                        <li v-if="currentPage < totalPages">
                            <button @click="setCurrentPage(currentPage + 1)">
                                <i class="fas fa-long-arrow-alt-right"></i>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentPage: Number,
        totalPages: Number,
    },
    methods: {
        setCurrentPage(page) {
            if (page !== this.currentPage) {
                this.$emit("update-current-page", page);
            }
        },
        pageButtonsArray() {
          if (this.totalPages < 2) {
            return [];
          }

          const maxPagesToShow = 5;
          const pages = [];

          if (this.totalPages <= maxPagesToShow) {
            for (let i = 1; i <= this.totalPages; i++) {
              pages.push(i);
            }
          } else {
            if (this.currentPage <= Math.ceil(maxPagesToShow / 2)) {
              for (let i = 1; i <= maxPagesToShow; i++) {
                pages.push(i);
              }
            } else if (this.currentPage >= this.totalPages - Math.floor(maxPagesToShow / 2)) {
              for (let i = this.totalPages - maxPagesToShow + 1; i <= this.totalPages; i++) {
                pages.push(i);
              }
            } else {
              for (let i = this.currentPage - Math.floor(maxPagesToShow / 2); i <= this.currentPage + Math.floor(maxPagesToShow / 2); i++) {
                pages.push(i);
              }
            }
          }

          return pages;
        },
    },
};
</script>
